import { DateTime } from 'luxon';


const generateRows = (
  users: ZazuAuditTrail[]
  // onAction: (token: UnifedUser, value: unknown, type: 'edit' | 'delete') => void
): TableRow[] =>
  users.map((user) => {

    const payload: TableRow = {
      locationId: user.locationId ?? '',
      contactId: user.contactId ?? '',
      input: user.input ?? '',
      output: user.output ?? '',
      model: user.model ?? '',
      // Empty unless the fallback served this turn, so a populated cell next to
      // Model reads as "answered by X instead of Y" at a glance.
      fallbackFromModel: user.fallbackFromModel ?? '',
      fallbackReason: user.fallbackReason ?? '',
      tool: user.tool ?? '',
      status: user.status ?? '',
      inputTokens: user.inputTokens ?? '',
      outputTokens: user.outputTokens ?? '',
      inputTokensDetails: user.inputTokensDetails ?? '',
      outputTokensDetails: user.outputTokensDetails ?? '',
      totalTokens: user.totalTokens ?? '',
      type: user.type ?? '',
      createdAt: user.createdAt ? DateTime.fromISO(user.createdAt).toLocaleString(DateTime.DATETIME_MED) : ''
      // linkData: {
      //   to: `${routes.SA_BillingTokens}/${token.id}`
      // }
    };

    return payload;
  });

export default generateRows;
